import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkTokenExpiry } from '../api/authCheck';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('token');

  // Jika tidak ada token, redirect ke halaman login
  if (!token) {
    return <Navigate to="/auth-pages/login" />;
  }

  // Cek apakah token sudah expired (decode JWT client-side)
  if (checkTokenExpiry()) {
    // checkTokenExpiry already cleared auth data & redirected
    return null;
  }

  // Jika ada token dan masih valid, render halaman yang diminta
  return children;
};

export default PrivateRoute;
